import axios from 'axios'
import { BUSCAR_TRECHOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarTrecho (codigoEmpresa, codigoRota) {
  const url = `${URL}/trecho/empresa/${codigoEmpresa}/rota/${codigoRota}/trechos`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_TRECHOS,
        payload: response

      })
  );
}
